export default __webpack_public_path__ + "/dist/images/client-icon.a6af29b0077db6f486e57d8451372219.svg";